module.exports = __webpack_public_path__ + "static/img/7.aeddd6a4.png";